/* Copyright Information: Created by BuyGroup */
import React, { Component } from "react";
import { Row, Col, Spinner } from "reactstrap";
import Product from "../components/product/Product";
import { getGroups } from "../services/HomeServices";
import Sidebar from "../sidebar/Sidebar";
// import SearchLogo from "../../public/icons/gis--map-search.svg"

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      groupList: [],
      count: 0,
      isLoading: false,
      showLoading: false,
      paramsMin: null,
      paramsMax: null,
      price: { min: 0, max: null },
      category_id: props.match.params.id,
      zipCode: '',
      zipCodeInput: '',
      accessCode: ''
    };
    this.debounceTimer = null;
  }

  componentDidMount() {
    this.getGroupList();
    const params = new URLSearchParams(window.location.search);
    const paramsMin = params.get("min");
    const paramsMax = params.get("max");
    const zipCode = params.get("zipCode") || '';
    const accessCode = params.get("accessCode") || '';

    let price = { min: 0, max: null };
    if (paramsMax !== null) {
      price.max = paramsMax;
    }
    if (paramsMin !== null) {
      price.min = paramsMin;
    }
    this.setState({ price: price, zipCode, zipCodeInput: zipCode, accessCode });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.getGroupList();
    }
  }

  // this function call api to get groups list
  getGroupList = () => {
    const params = new URLSearchParams(window.location.search);
    const paramsMin = params.get("min");
    const paramsMax = params.get("max");
    const zipCode = params.get("zipCode") || "";
    const accessCode = params.get("accessCode") || "";
    this.setState({
      isLoading: true,
      paramsMin: paramsMin,
      paramsMax: paramsMax,
      category_id: this.props.match.params.id,
      zipCode: zipCode,
      accessCode,
    });
    let filterData = { limit: 12, offset: 0, zip_code: zipCode };
    if (paramsMax !== null) {
      filterData.max = paramsMax;
    }
    if (paramsMin !== null) {
      filterData.min = paramsMin;
    }
    if (accessCode) {
      filterData.accessCode = accessCode;
    }
    getGroups(filterData)
      .then((response) => {
        if (response.data !== undefined) {
          this.setState({
            groupList: response.data,
            isLoading: false,
            count: response.data.length,
            offset: 0,
          });
        }
      })
      .catch((error) => {
        console.log("error in group List", error);
        this.setState({ isLoading: false });
      });
  };

  loadMore = () => {
    this.setState({ offset: this.state.offset + 1 }, () => {
      this.loadMoreGroupList();
    });
  };

  /* This Function will call api and Load More Group list */
  loadMoreGroupList = () => {
    this.setState({ showLoading: true });
    const params = new URLSearchParams(window.location.search);
    const paramsMin = params.get("min");
    const paramsMax = params.get("max");
    let zipCode = params.get("zipCode") || '';
    let accessCode = params.get("accessCode") || '';
    let filterData = {
      limit: 12,
      offset: this.state.offset,
      zip_code: zipCode,
    };
    if (paramsMax !== null) {
      filterData.max = paramsMax;
    }
    if (paramsMin !== null) {
      filterData.min = paramsMin;
    }
    if (accessCode) {
      filterData.accessCode = accessCode;
    }
    getGroups(filterData)
      .then((response) => {
        if (response.data !== undefined) {
          let groupList = [...this.state.groupList];

          let newArray = groupList.concat(response.data);
          this.setState({
            groupList: newArray,
            showLoading: false,
            count: response.data.length,
          });
        }
      })
      .catch((error) => {
        console.log("error in group List", error);
        this.setState({ showLoading: false });
      });
  };

  // Handle zipcode input change with debouncing
  handleZipCodeChange = (e) => {
    const zipCode = e.target.value;
    this.setState({ zipCodeInput: zipCode });

    // Clear previous timer
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer);
    }

    // Set new timer for debouncing (1000ms delay)
    this.debounceTimer = setTimeout(() => {
      if (zipCode.length === 5 && /^\d{5}$/.test(zipCode)) {
        // Update URL params
        const params = new URLSearchParams(window.location.search);
        params.set('zipCode', zipCode);

        // Update browser URL without page reload
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);

        this.setState({ zipCodeInput: '' });

        // Update state and refresh the group list
        this.setState({ zipCode: zipCode }, () => {
          this.getGroupList();
        });
      }
    }, 1000);
  };

  render() {
    console.log('HomePage render: zipCode state:', this.state.zipCode);
    return (
      <>
        <Row>
          <Col sm="3" className="collection-filter">
            <Sidebar
              minValue={this.state.paramsMin}
              maxValue={this.state.paramsMax}
              zipCode={this.state.zipCode}
              accessCode={this.state.accessCode}
            />
          </Col>
          <Col lg="9" sm="12" xs="12" className="product-grid-view">
            <div className="theme-card theme-card-icon">
              <h5 class=""></h5>
              <div className="hidden">
                <i className="fa fa-th grid-layout-view mr-2"></i>
                <i className="fa fa-list-ul list-layout-view"></i>
              </div>
            </div>
            {/* {this.state.isLoading ? (
              <div className="custom-loader">
                <Spinner animation="border" />
              </div>
            ) : !this.state.zipCode ? (
              <div className="zipcode-not-available">
                <img src={'/icons/gis--map-search.svg'} alt="Search Logo" />
                <h3>Find products in your area</h3>
                <p>Please enter your ZIP code to view available products in your area</p>
                <div className="zipcode-form">
                <div className="zipcode-input-wrapper">
                  <input
                    type="text"
                    value={this.state.zipCodeInput}
                    onChange={this.handleZipCodeChange}
                    placeholder="Enter ZIP code"
                    maxLength="5"
                    className="zipcode-input"
                  />
                </div>
                </div>
              </div>
            ) : (
              <div className="product_listing">
                <div className="product-wrapper-grid">
                  {this.state.groupList.length > 0 ? (
                    <div className="row">
                      {this.state.groupList.map((group, index) => {
                        return <Product group={group} key={index} />;
                      })}
                    </div>
                  ) : (
                    <div className="NotAvailableBox">
                      <p>No Groups Available</p>
                    </div>
                  )}
                  {this.state.count === 12 && (
                    <div className="text-center">
                      <button
                        onClick={this.loadMore}
                        type="submit"
                        disabled={this.state.showLoading}
                        color="primary"
                        className="btn btn-solid"
                      >
                        {this.state.showLoading ? "loading..." : "Load More"}
                      </button>
                    </div>
                  )}
                </div>
              </div>
            )} */}

            {
              this.state.isLoading ?
                (
                  <div className="custom-loader">
                    <Spinner animation="border" />
                  </div>
                ) :
                this.state.groupList.length > 0 ?
                  (
                    <div className="product_listing">

                      <div className="product-wrapper-grid">

                        <div className="row">
                          {this.state.groupList.map((group, index) => {
                            return <Product group={group} key={index} accessCode={this.state.accessCode} />;
                          })}
                        </div>

                        {this.state.count === 12 && (
                          <div className="text-center">
                            <button
                              onClick={this.loadMore}
                              type="submit"
                              disabled={this.state.showLoading}
                              color="primary"
                              className="btn btn-solid"
                            >
                              {this.state.showLoading ? "loading..." : "Load More"}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  ) 
                  // : !this.state.zipCode || !this.state.accessCode ?
                  //   (
                  //     <div className="zipcode-not-available">
                  //       <img src={'/icons/gis--map-search.svg'} alt="Search Logo" />
                  //       <h3>Find products in your area</h3>
                  //       <p>Please enter your ZIP code to view available products in your area</p>
                  //       <div className="zipcode-form">
                  //         <div className="zipcode-input-wrapper">
                  //           <input
                  //             type="text"
                  //             value={this.state.zipCodeInput}
                  //             onChange={this.handleZipCodeChange}
                  //             placeholder="Enter ZIP code"
                  //             maxLength="5"
                  //             className="zipcode-input"
                  //           />
                  //         </div>
                  //       </div>
                  //     </div>
                  //   )
                    : (
                      <div className="NotAvailableBox">
                        <p>No Groups Available</p>
                      </div>
                    )
            }
          </Col>
        </Row>
      </>
    );
  }
}

export default HomePage;
/* Copyright Information: Created by BuyGroup */
